import { TributeInfo } from './tribute-info.model';

export class SetTributeID {
  static readonly type = '[TributeInfo] Set Tribute ID';
  constructor(public payload: string) {}
}
export class SetTributeCompleted {
  static readonly type = '[TributeInfo] Set Tribute Completed';
  constructor(public payload: boolean) {}
}
export class SetTributeInfo {
  static readonly type = '[TributeInfo] Set Tribute Info';
  constructor(public payload: TributeInfo) {}
}
